export enum DELETE_SCHEDULE_OPTION {
  ONLY_THIS_INSTANCE = "Only This Instance",
  ALL_INSTANCES = "All Instances",
}
